// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__sqW82","images":"Hero_images__XPlCJ","title":"Hero_title__D3nDC","subtitle":"Hero_subtitle__yZiCC","button":"Hero_button__vZtYY"};